import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "hovered", "pointySide", "$isBetaButton", "$minimized"];
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { getFabAfterStyles, getFabBeforeStyles, getFabBetaButtonStyles, getFabMinimizedStyles, getFabStyles } from './FloatingActionButton.helpers';
import { ActiveProvider } from '../../../transitional/utils/useActive';
import { Clickable } from '../../../transitional/components/Clickable/Clickable';
import { HoverProvider } from '../../../transitional/utils/useHovered';
import { filterProps } from '../../../utils/filterProps';
import styled from 'foundations-theming/utils';
import { useFloatingActionButtonContext } from './FloatingActionButtonProvider';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const Fab = styled(_ref => {
  let rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Clickable, Object.assign({}, rest));
}).withConfig({
  displayName: "FloatingActionButton__Fab"
})(["", ";", ";", ";&::after{", "}&::before{", "}"], props => getFabStyles(props), props => props.$isBetaButton && getFabBetaButtonStyles(props), props => props.$minimized && getFabMinimizedStyles(), props => getFabAfterStyles(props), props => getFabBeforeStyles(props));
export const FloatingActionButton = _ref2 => {
  let {
      children,
      minimized = false,
      pointySide = 'bottom-left',
      style,
      [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, ["children", "minimized", "pointySide", "style", DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE].map(_toPropertyKey));
  const {
    isBetaButton
  } = useFloatingActionButtonContext();
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(HoverProvider, {
    children: hoverProviderProps => /*#__PURE__*/_jsx(ActiveProvider, {
      children: activeProviderProps => /*#__PURE__*/_jsx(Fab, Object.assign({}, hoverProviderProps, activeProviderProps, {
        pointySide: pointySide,
        $cssStyles: cssStyles,
        $isBetaButton: isBetaButton,
        $minimized: minimized,
        style: style
      }, domProps, callbackProps, {
        [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute || 'FloatingActionButton',
        children: children
      }))
    })
  });
};
FloatingActionButton.displayName = 'FloatingActionButton';